module.exports = __webpack_public_path__ + "static/media/DecSelfie.barcalys.90ac39d1.tsx";